export const INFORMATION_MENU_NOTICE = 'information.page.menu.notice';
export const INFORMATION_MENU_COMMUNITY = 'information.page.menu.community';

export const INFORMATION_STEP_CREATE = 'information.page.step.create';
export const INFORMATION_STEP_EDIT = 'information.page.step.edit';

const LEGACY_INFORMATION_MENU_MAP: Record<string, string> = {
	공지사항: INFORMATION_MENU_NOTICE,
	자유게시판: INFORMATION_MENU_COMMUNITY,
};

const LEGACY_INFORMATION_STEP_MAP: Record<string, string> = {
	등록: INFORMATION_STEP_CREATE,
	수정: INFORMATION_STEP_EDIT,
};

export const normalizeInformationMenu = (value?: string | null) => {
	if (!value) {
		return INFORMATION_MENU_NOTICE;
	}

	if (value === INFORMATION_MENU_NOTICE || value === INFORMATION_MENU_COMMUNITY) {
		return value;
	}

	return LEGACY_INFORMATION_MENU_MAP[value] ?? INFORMATION_MENU_NOTICE;
};

export const normalizeInformationStep = (value?: string | null) => {
	if (!value) {
		return '';
	}

	if (value === INFORMATION_STEP_CREATE || value === INFORMATION_STEP_EDIT) {
		return value;
	}

	return LEGACY_INFORMATION_STEP_MAP[value] ?? '';
};
